export const ROUTES = {
    HOME: '/',
    DASHBOARD: '/dashboard',
    DASHBOARD_KPI_THUONG: '/dashboard-kpi-thuong',
    THONG_KE_KPI_KHONG_DAT: '/thong-ke-kpi-khong-dat',
    BUOC6: '/buoc6',
    BUOC6_CHI_TIEU_CHA_CON: '/buoc6/chi-tieu-cha-con',
    INTRO: '/intro',
    LOGIN: '/login',
    LOGOUT: '/logout',
    AUTH_SESSION_CHANGED: '/auth-session-changed',
    DB_RESTORE_LOCK: '/db-restore-lock',
    IDLE: '/idle',
    VAN_HOA: {
        HOME: '/van-hoa/',
        DASHBOARD: '/van-hoa/dashboard',
        NGOI_NHA: '/van-hoa/ngoi-nha',
        HANH_VI_THEN_CHOT: '/van-hoa/hanh-vi-then-chot',
        AN_LE: '/van-hoa/an-le',
        CAU_HOI_AN_LE: '/van-hoa/cau-hoi-an-le',
        KS_VH_HIEN_TAI_TUONG_LAI: '/van-hoa/dot-danh-gia/khao-sat-van-hoa-hien-tai-tuong-lai',
        /** Báo cáo hiện tại–tương lai; `id` mặc định `0` khi chưa chọn đợt. */
        BAO_CAO_HIEN_TAI_TUONG_LAI: (dotDanhGiaId: string | number = 0) =>
            `/van-hoa/dot-danh-gia/bao-cao/${encodeURIComponent(String(dotDanhGiaId))}/hientaituonglai/`,
        XUONG_CA_KE_HOACH: '/van-hoa/xuong-ca-ke-hoach',
        LOGFILES: '/van-hoa/logfiles',
    },
    QUY_TRINH: {
        DASHBOARD: '/quy-trinh/',
        SO_DO_TO_CHUC: '/quy-trinh/so-do-to-chuc',
    },
};
